const NEXT_KEYS = new Set(["ArrowDown", "ArrowRight"]);
const PREVIOUS_KEYS = new Set(["ArrowUp", "ArrowLeft"]);

/**
 * Where a key lands in a WAI-ARIA radio group of `count` options, from the option at `current`: arrows
 * move one option and wrap at both ends, Home/End jump to the first/last. Left/Right swap under RTL
 * (`isRtl`: read it from the element's computed `direction`, since this app flips `body.dir`, not the
 * MUI theme). Null for any other key, which the group should leave alone. Shared by the radio groups
 * (`VisualChoiceGrid`, `SystemChoiceList` pick mode) so they move the same way.
 */
export const radioGroupTargetIndex = (key: string, current: number, count: number, isRtl: boolean): number | null => {
	if (key === "Home") return 0;
	if (key === "End") return count - 1;
	const horizontalFlip = isRtl && (key === "ArrowLeft" || key === "ArrowRight");
	if (NEXT_KEYS.has(key)) return (current + (horizontalFlip ? -1 : 1) + count) % count;
	if (PREVIOUS_KEYS.has(key)) return (current + (horizontalFlip ? 1 : -1) + count) % count;
	return null;
};
